<template>
  <div>
    <header class="navbar navbar-expand-md navbar-light d-print-none">
      <div class="container-xl">
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-menu"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <h1
          class="
            navbar-brand navbar-brand-autodark
            d-none-navbar-horizontal
            pe-0 pe-md-3
          "
        >
          <a href="/">
            <img
              :src="require('../assets/images/logo-dark.png')"
              width="110"
              height="32"
              alt="Tabler"
              class="navbar-brand-image"
            />
          </a>
        </h1>
        <div class="navbar-nav flex-row order-md-last">
          <div class="nav-item dropdown">
            <a
              href="#"
              class="nav-link d-flex lh-1 text-reset p-0"
              data-toggle="dropdown"
            >
              <span
                class="avatar avatar-sm"
                :style="{
                  background: '#fff center/cover',
                  backgroundImage:
                    'url(\'' + require('../assets/images/merchant.png') + '\')',
                }"
              ></span>
              <div class="d-none d-xl-block pl-2">
                <div>{{ memberInfo.email }}</div>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
              <router-link v-if="!isDemoAccount" to="myProfile" class="dropdown-item"
                >個人資訊</router-link
              >
              <router-link v-if="!isDemoAccount" to="storeSetting" class="dropdown-item"
                >商店設定</router-link
              >
              <div v-if="!isDemoAccount" class="dropdown-divider"></div>
              <router-link v-if="!isDemoAccount" to="assets" class="dropdown-item">資產</router-link>
              <div v-if="!isDemoAccount" class="dropdown-divider"></div>
              <a v-if="!isDemoAccount" href="http://usd2pay.com/sample.php.zip" class="dropdown-item"
                >範例下載</a
              >
              <div v-if="!isDemoAccount" class="dropdown-divider"></div>
              <a href="#" class="dropdown-item" @click.prevent="signout"
                >登出</a
              >
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="navbar-expand-md">
      <div class="collapse navbar-collapse" id="navbar-menu">
        <div class="navbar navbar-light">
          <div class="container-xl">
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link class="nav-link" to="dashboard">
                  <span class="nav-link-icon d-md-none d-lg-inline-block"
                    ><svg
                      height="24"
                      viewBox="0 0 512 512"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m197.332031 170.667969h-160c-20.585937 0-37.332031-16.746094-37.332031-37.335938v-96c0-20.585937 16.746094-37.332031 37.332031-37.332031h160c20.589844 0 37.335938 16.746094 37.335938 37.332031v96c0 20.589844-16.746094 37.335938-37.335938 37.335938zm-160-138.667969c-2.941406 0-5.332031 2.390625-5.332031 5.332031v96c0 2.945313 2.390625 5.335938 5.332031 5.335938h160c2.945313 0 5.335938-2.390625 5.335938-5.335938v-96c0-2.941406-2.390625-5.332031-5.335938-5.332031zm0 0"
                      />
                      <path
                        d="m197.332031 512h-160c-20.585937 0-37.332031-16.746094-37.332031-37.332031v-224c0-20.589844 16.746094-37.335938 37.332031-37.335938h160c20.589844 0 37.335938 16.746094 37.335938 37.335938v224c0 20.585937-16.746094 37.332031-37.335938 37.332031zm-160-266.667969c-2.941406 0-5.332031 2.390625-5.332031 5.335938v224c0 2.941406 2.390625 5.332031 5.332031 5.332031h160c2.945313 0 5.335938-2.390625 5.335938-5.332031v-224c0-2.945313-2.390625-5.335938-5.335938-5.335938zm0 0"
                      />
                      <path
                        d="m474.667969 512h-160c-20.589844 0-37.335938-16.746094-37.335938-37.332031v-96c0-20.589844 16.746094-37.335938 37.335938-37.335938h160c20.585937 0 37.332031 16.746094 37.332031 37.335938v96c0 20.585937-16.746094 37.332031-37.332031 37.332031zm-160-138.667969c-2.945313 0-5.335938 2.390625-5.335938 5.335938v96c0 2.941406 2.390625 5.332031 5.335938 5.332031h160c2.941406 0 5.332031-2.390625 5.332031-5.332031v-96c0-2.945313-2.390625-5.335938-5.332031-5.335938zm0 0"
                      />
                      <path
                        d="m474.667969 298.667969h-160c-20.589844 0-37.335938-16.746094-37.335938-37.335938v-224c0-20.585937 16.746094-37.332031 37.335938-37.332031h160c20.585937 0 37.332031 16.746094 37.332031 37.332031v224c0 20.589844-16.746094 37.335938-37.332031 37.335938zm-160-266.667969c-2.945313 0-5.335938 2.390625-5.335938 5.332031v224c0 2.945313 2.390625 5.335938 5.335938 5.335938h160c2.941406 0 5.332031-2.390625 5.332031-5.335938v-224c0-2.941406-2.390625-5.332031-5.332031-5.332031zm0 0"
                      />
                    </svg>
                  </span>
                  <span class="nav-link-title"> Dashboard </span>
                </router-link>
              </li>
              <li v-if="!isDemoAccount" class="nav-item">
                <router-link class="nav-link" to="customerWithdrawal">
                  <span class="nav-link-icon d-md-none d-lg-inline-block"
                    >
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 480 480" style="enable-background:new 0 0 480 480;" xml:space="preserve">
                      <g>
                        <g>
                          <path d="M336.168,343.833c-3.126-3.126-8.194-3.126-11.32,0L248,420.689V200.001c0-4.418-3.582-8-8-8s-8,3.582-8,8v220.688
                            l-76.848-76.856c-3.126-3.126-8.194-3.126-11.32,0c-3.126,3.126-3.126,8.194,0,11.32l90.504,90.496
                            c3.12,3.128,8.186,3.135,11.314,0.014c0.005-0.005,0.01-0.01,0.014-0.014l90.504-90.496
                            C339.294,352.027,339.294,346.959,336.168,343.833z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M456,32.001H24c-13.255,0-24,10.745-24,24v288c0,13.255,10.745,24,24,24h80c4.418,0,8-3.582,8-8s-3.582-8-8-8H24
                            c-4.418,0-8-3.582-8-8v-216h448v216c0,4.418-3.582,8-8,8h-80c-4.418,0-8,3.582-8,8s3.582,8,8,8h80c13.255,0,24-10.745,24-24v-288
                            C480,42.746,469.255,32.001,456,32.001z M464,96.001H16v-40c0-4.418,3.582-8,8-8h432c4.418,0,8,3.582,8,8V96.001z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M232,144.001H56c-4.418,0-8,3.582-8,8s3.582,8,8,8h176c4.418,0,8-3.582,8-8S236.418,144.001,232,144.001z"/>
                        </g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      </svg>
                  </span>
                  <span class="nav-link-title"> 客戶出金 </span>
                </router-link>
              </li>
              <!-- <li class="nav-item dropdown">
                <router-link class="nav-link" to="transactionList">
                  <span class="nav-link-icon d-md-none d-lg-inline-block">
                    <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 477.867 477.867"
                      style="enable-background:new 0 0 477.867 477.867;"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M426.667,0H51.2C22.923,0,0,22.923,0,51.2v375.467c0,28.277,22.923,51.2,51.2,51.2h375.467
			c28.277,0,51.2-22.923,51.2-51.2V51.2C477.867,22.923,454.944,0,426.667,0z M443.733,426.667c0,9.426-7.641,17.067-17.067,17.067
			H51.2c-9.426,0-17.067-7.641-17.067-17.067V51.2c0-9.426,7.641-17.067,17.067-17.067h375.467c9.426,0,17.067,7.641,17.067,17.067
			V426.667z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M153.6,102.4h-51.2c-9.426,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h51.2
			c9.426,0,17.067-7.641,17.067-17.067S163.026,102.4,153.6,102.4z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M375.467,102.4h-153.6c-9.426,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h153.6
			c9.426,0,17.067-7.641,17.067-17.067S384.892,102.4,375.467,102.4z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M153.6,221.867h-51.2c-9.426,0-17.067,7.641-17.067,17.067S92.974,256,102.4,256h51.2c9.426,0,17.067-7.641,17.067-17.067
			S163.026,221.867,153.6,221.867z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M375.467,221.867h-153.6c-9.426,0-17.067,7.641-17.067,17.067S212.441,256,221.867,256h153.6
			c9.426,0,17.067-7.641,17.067-17.067S384.892,221.867,375.467,221.867z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M153.6,341.333h-51.2c-9.426,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h51.2
			c9.426,0,17.067-7.641,17.067-17.067S163.026,341.333,153.6,341.333z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M375.467,341.333h-153.6c-9.426,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h153.6
			c9.426,0,17.067-7.641,17.067-17.067S384.892,341.333,375.467,341.333z"
                          />
                        </g>
                      </g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                    </svg>
                  </span>
                  <span class="nav-link-title"> 交易列表 </span>
                </router-link>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { DEMO_TOKEN } from "@/demo/mockSession";
export default {
  data() {
    return {
      memberInfo: { email: "" },
      isDemoAccount: false,
    };
  },
  methods: {
    async signout() {
      Cookies.remove("USD2PayToken");
      Cookies.remove("Usd2payInfo");
      this.$router.push("login");
    },
    async getMemberInfo() {
      const info = Cookies.get("Usd2payInfo");
      this.memberInfo.email = atob(info);
      this.isDemoAccount = Cookies.get("USD2PayToken") === DEMO_TOKEN;
    },
  },
  created() {
    this.getMemberInfo();
  },
};
</script>
